import { createFinders } from '@wix/data-hooks-unidriver'
import { HeadingUniDriver, RadioGroupUniDriver } from '@wix/design-system/dist/testkit/unidriver'
import { ChoiceQuestionContentComponent } from '@wix/funnel-builder-lizard'
import { UniDriver } from '@wix/unidriver-core'

import { dataHooks } from './Question.dataHooks'

export const QuestionDriver = <T>(base: UniDriver<T>) => {
  const { title } = createFinders(base, dataHooks)
  const titleDriver = HeadingUniDriver(title.find(), base)
  const radioGroupDriver = RadioGroupUniDriver(base, base)

  const contentMatches = async ({
    content,
    options,
  }: ChoiceQuestionContentComponent<{ title: string }, { label: string }>) => {
    const optionsMatch = await Promise.all(
      options.map(async (option, index) => {
        const radioDriver = await radioGroupDriver.getRadioAtIndex(index)
        const radioLabel = await radioDriver.getLabel()
        return radioLabel === option.label
      }),
    )
    const titleMatches = await titleDriver.getText().then(value => value === content.title)

    return ![titleMatches, ...optionsMatch].includes(false)
  }

  return {
    exists: base.exists,
    contentMatches,
    selectOptionAt: radioGroupDriver.selectByIndex,
  }
}
